import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { HcaBookingService } from '../../../../../shared/_services/hca-booking.service';
import { UtilService } from '../../../../../shared/_services/util.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { DiscountPointsComponent } from '../../../../modals/discount-points/discount-points.component';

@Component({
  selector: 'app-bookings-list',
  templateUrl: './bookings-list.component.html',
  styleUrls: ['./bookings-list.component.scss']
})
export class BookingsListComponent implements OnInit {
  filterForm: FormGroup;
  searchForm: FormGroup;
  bookingsList: any[] = [];
  bookingRulesList: any;
  isFiltered: any;
  isFilterOn: any;
  p: number = 0;
  size: number = 10;
  totalCount: any;
  filterLookUpData: any;
  activateAction: boolean;
  allBookingsSelected: boolean;
  selectedBookings: any[] = [];
  statusModal: BsModalRef;
  bsModalRef: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  tableHeader: any = [
    { 'key': 'Locator', 'property': 'locator', 'direction': 'asc' },
    { 'key': 'Reservation Number', 'property': 'pmsBookingReference', 'direction': 'asc' },
    { 'key': 'Manual updated at', 'property': 'manualUpdatedDate', 'direction': null },
    { 'key': 'Origin', 'property': 'origin', 'direction': null },
    { 'key': 'PMS ID', 'property': 'pmsId', 'direction': null },
    { 'key': 'PMS Bonus', 'property': 'pmsBonus', 'direction': null },
    { 'key': 'Agency', 'property': 'agency', 'direction': null },
    { 'key': 'PMS Title', 'property': 'pmsEntitler', 'direction': null },
    //{ 'key': 'Treatment', 'property': 'treatment', 'direction': null },
    { 'key': 'Hotel', 'property': 'hotelName', 'direction': null },
    { 'key': 'Checkin', 'property': 'checkInDate', 'direction': null },
    { 'key': 'Checkout', 'property': 'checkOutDate', 'direction': null },
    { 'key': 'State', 'property': 'state', 'direction': null },
    { 'key': 'Agent Name', 'property': 'agentName', 'direction': null }
  ];


  constructor(
    private fb: FormBuilder,
    private utilService: UtilService,
    private modalService: BsModalService,
    private hcaBookingService: HcaBookingService
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));
    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "member-edit") {
            if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
              let status = +this.statusModal.content.srcObject.status;
              this.activateOrDeactivateBooking(this.statusModal.content.srcObject.id, status);
            } else {
              // this.router.navigate(['/members']);
            }
          }
        }
      } else {
        // this.pageChanged(1);
        // this.pageChanged(this.p > 1 ? this.p : 1);
      }
    })
   }

   activateOrDeactivateBooking(bookingIds, status) {
    this.hcaBookingService.activateOrDeactivateBooking(bookingIds, status).subscribe(res => {
      if (res.error == 0) {
        this.pageChanged(this.p > 1 ? this.p : 1);
      }
    }, err => {
      console.error('Error Activating/Deactivating Booking: ', err.message);
    })
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this Booking(s)?" : "Are you sure you want to activate this Booking(s)?";
    let title = mode == 0 ? "Deactivate Booking" : "Activate Booking";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  calculateDiscount(id) {
    this.bsModalRef = this.modalService.show(DiscountPointsComponent, { class: 'modal-import' });
    this.bsModalRef.content.bookingIds = id;
  }

  dropDown(e) {
    // event.stopPropagation();
    if (document.getElementById('ul').style.display == 'block') {
      document.getElementById('ul').style.display = 'none';
    } else {
      document.getElementById('ul').style.display = 'block';
    }
  }

  offClickHandler(event: any) {
    if (!event.target.closest(".filter") && !event.target.closest(".filter")) {
      // do whatever you want here
      if (document.getElementById('ul')) {
        document.getElementById('ul').style.display = 'none';
      }
    }
  }

  sortTable(property: any, ignoreFields?) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property && (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1)) {
        header.direction = null;
      }
    });
    if (ignoreFields && ignoreFields.length && ignoreFields.indexOf(property) == -1) {
      this.pageChanged(1);
    }
  }

  sortTable1(property: any) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property) {
        header.direction = null;
      }
    });
    this.pageChanged(1);
  }

  getfilterLookUpData() {
    this.hcaBookingService.getLookupDataForBooking().subscribe(res => {
      if (res.error == 0) {
        this.filterLookUpData = res.responseObj;
        this.checkSelected(true, 'hotelIds', 'hotels', 'hotelId', 0);
        this.checkSelected(true, 'origins', 'origin', 'origin', 0);
      }
    }, err => {
      console.error('Error while getting filter look up date: ', err.message);
    })
  }

  get getSelectedBookings() {
    return this.utilService.cleanArray(this.bookingsList.map(booking => {
      if (booking.checked) {
        this.activateAction = true;
        return booking.bookingId;
      } else {
        this.activateAction = false;
        return null;
      }
    }))
  }

  selectBookings(type) {
    if (type == 'all') {
      for (var i = 0; i < this.bookingsList.length; i++) {
        this.bookingsList[i].checked = this.allBookingsSelected;
      }
    } else {
      this.allBookingsSelected = this.bookingsList.every(function (item: any) {
        return item.checked == true;
      })
    }
    this.selectedBookings = this.getSelectedBookings;
  }

  pageChanged($event) {
    const page = $event - 1;
    this.getBookingsList(page);
    this.allBookingsSelected = false;
    this.selectBookings('all');
    this.p = $event;
  }

  getBookingsList(page?) {
    let data = {
      filter: this.filterForm.value,
      isFilterOn: this.isFilterOn,
      pageNumber: page != null ? page : this.p,
      hotelChainId: JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId,
      value: this.searchForm.get('searchTerm').value,
      sorting: this.tableHeader
    }
    this.hcaBookingService.getBookingsList(data).subscribe(res => {
      if (res.error == 0) {
        this.isFiltered = this.checkGroupFilter();
        this.bookingsList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords;
      }
    }, err => {
      console.error('Error while fetching Booking List: ', err.message);
    })
  }

  checkGroupFilter() {
    if (!this.isFilterOn && !this.searchForm.get('searchTerm').value) {
      return false;
    } else {
      return true;
    }
  }

  checkSelected(isChecked: boolean, controlName, type, valueType, value) {
    let formArray = this.filterForm.controls[controlName] as FormArray;
    if (isChecked) {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
        formArray.push(new FormControl(0));
        this.filterLookUpData[type].forEach(value => {
          formArray.push(new FormControl(valueType == 'origin' ? value : value[valueType]));
        });
      } else {
        formArray.push(new FormControl(value));
        if (formArray.value.indexOf(0) == -1 && this.filterLookUpData[type].length == formArray.value.length) {
          formArray.push(new FormControl(0));
        }
      }
    } else {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
      } else {
        let index = formArray.controls.findIndex(x => x.value == value);
        if (index > -1) {
          formArray.removeAt(index);
        }
        if (formArray.value.indexOf(0) > -1) {
          if (this.filterLookUpData[type].length != formArray.value.length - 1) {
            let idx = formArray.controls.findIndex(x => x.value == 0);
            if (idx > -1) {
              formArray.removeAt(idx);
            }
          }
        }
      }
    }
  }

  selectedValue(control, value) {
    this.filterForm.controls[control].setValue(value);
  }

  clearDate(){
    if(this.filterForm.get('range').value){
      this.filterForm.get('range').setValue(null);
      this.filterForm.get('startDate').setValue(null);
      this.filterForm.get('endDate').setValue(null);
    }
  }

  searchTerm() {
    this.pageChanged(1);
  }

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  checkFilterOn() {
    let formGroup = this.filterForm.value;
    if (!formGroup.startDate && !formGroup.endDate && !formGroup.status && !formGroup.stateId && !formGroup.direct && formGroup.origins && formGroup.origins.indexOf(0) > -1 && formGroup.hotelIds && formGroup.hotelIds.indexOf(0) > -1) {
      return false;
    } else {
      return true;
    }
  }

  initfilterForm() {
    let hotels = this.fb.array([]);
    let origins = this.fb.array([]);
    this.filterForm = this.fb.group({
      status: [''],
      direct: [''],
      hotelIds: hotels,
      origins: origins,
      stateId: [''],
      range: [null],
      startDate: [null],
      endDate: [null],

    });
    this.filterForm.controls['range'].valueChanges.debounceTime(200).subscribe(value => {
      if (!value || (value && !value.length)) {
        this.filterForm.get('startDate').setValue(null);
        this.filterForm.get('endDate').setValue(null);
      } else {
        this.filterForm.get('startDate').setValue(value[0] ? this.utilService.formatDate(value[0]) : null);
        this.filterForm.get('endDate').setValue(value[1] ? this.utilService.formatDate(value[1]) : null);
      }
    })
    this.filterForm.valueChanges.debounceTime(400).distinctUntilChanged().subscribe(value => {
      this.isFilterOn = this.checkFilterOn();
      this.pageChanged(1);
    })
  }

  initSearchForm() {
    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
  }

  ngOnInit() {
    this.getfilterLookUpData();
    this.initfilterForm();
    this.initSearchForm();
    this.getBookingsList();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/bookings/bookings-list/bookings-list.component.ts